<template>
  <el-scrollbar class="x_scroll" style="height: 100%">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-card class="box-card" v-for="item in visitDetail" :key="item.id">
        <div slot="header">
          <h4>{{ item.nodeName }}</h4>
        </div>
        <el-col :span="getSpan(sub)" v-for="sub in item.children" :key="sub.id">
          <el-form-item :label-width="getLabelWidth(sub)">
            <div slot="label">
              <span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="sub.remark ? sub.remark : ''"
                  placement="top-start"
                >
                  <i v-if="sub.remark" class="el-icon-question"></i>
                </el-tooltip>
                <span>{{ `${sub.nodeName}:` }}</span>
              </span>
            </div>
            <!-- inputValueFormat  输入格式类型：0、填空；1、单选；2多选；3JSONObject；4JSONArray；5前端定义；； -->
             <el-input
              :disabled="type===1"
              v-if="sub.inputValueFormat === 0"
              v-model="ruleForm[item.nodeCode][sub.nodeCode]"
            ></el-input>
            <el-radio-group
              :disabled="type===1"
              v-else-if="sub.inputValueFormat === 1"
              v-model="ruleForm[item.nodeCode][sub.nodeCode]"
            >
              <el-radio
                v-for="option in sub.options"
                :key="option.id"
                :label="option.id"
                >{{ option.optionValue }}</el-radio
              >
            </el-radio-group>
            <el-checkbox-group :disabled="type===1" v-else-if="sub.inputValueFormat === 2" v-model="ruleForm[item.nodeCode][sub.nodeCode]">
              <el-checkbox  v-for="option in sub.options"
                :key="option.id"
                :label="option.id">
                {{option.optionValue}}
              </el-checkbox>
            </el-checkbox-group>
            <template v-else-if="sub.inputValueFormat === 5">
              <el-radio-group
                :disabled="type===1"
                v-if="sub.nodeName === '药物不良反应'"
                v-model="ruleForm[item.nodeCode][sub.nodeCode]"
              >
                <el-radio
                  :disabled="type===1"
                  v-for="option in sub.options"
                  :key="option.id"
                  :label="option.id"
                  >{{ option.optionValue }}</el-radio
                >
                <el-input
                  :disabled="type===1"
                  v-show="ruleForm[item.nodeCode][sub.nodeCode] === 21"
                  v-model="ruleForm[item.nodeCode][`${sub.nodeCode}:remark`]"
                ></el-input>
              </el-radio-group>
            </template>
            <template v-else-if="sub.inputValueFormat === 3"> </template>
          </el-form-item>
        </el-col>
      </el-card>
      <el-form-item v-if="type===2">
        <el-button @click="resetForm('ruleForm')">取消</el-button>
        <el-button type="primary" :loading="loading" @click="onSave"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </el-scrollbar>
</template>

<script>
import {memberArchiveSaveOrUpdateRecord} from '@/api/system/member'
export default {
  props: {
    type: {  // 1 为会员 2为建档
      default: 1,
      type: Number
    },
    visitDetail: {
      type: Array,
      default() {
        return {};
      }
    },
    memberId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      ruleForm: {
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change"
          }
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" }
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }]
      }
    };
  },
  watch: {
    visitDetail: {
      handler: function(val) {
        val.forEach(item => {
          const obj = {};
          if (typeof item.children === "object") {
            this.$set(this.ruleForm, item.nodeCode, {});
            item.children.forEach(sub => {
              if (sub.inputValueFormat === 2) {
                
                 this.$set(
                  this.ruleForm[item.nodeCode],
                  sub.nodeCode,
                  sub.inputValues?sub.inputValues: []
                );
              } else {
                this.$set(
                  this.ruleForm[item.nodeCode],
                  sub.nodeCode,
                  sub.inputValues
                );
              }
            });
          }
        });
      },
      immediate: true
    }
  },
  methods: {
        /**
     * 重置表单
     */
    reset() {
      // this.$refs['ruleForm'].resetFields()
      for(let key in this.ruleForm) {
        if(key.indexOf(':') === -1) {
          this.ruleForm[key] = undefined
        }else {
          const obj = this.ruleForm[key]
          for(let key2 in obj) {
             if(Object.prototype.toString.call(obj[key2]).slice(8,-1) === 'Array') {
              obj[key2] = []
            }else {
              obj[key2] = undefined
            }
          }
        }
      }
    },
    getLabelWidth(sub) {
      if(sub.inputValueFormat === 0) {
        return '120px'
      }else {
        return '100px'
      }
    },
    // getSpan
    getSpan(sub) {
      // console.log('sub=====>', sub);
      if(sub.options>4) {
        return 24
      }else {
        return 24
      }
    },
    // 封装数据
    formatData(data) {
      const arr = [];
      let count = 0;
      const recursion = function(obj) {
        for (let key in obj) {
          if (Object.prototype.toString.call(obj[key]).slice(8,-1)  === "Object") {
            recursion(obj[key]);
          } else {
            if (key.indexOf(":") !== -1) {
              arr.push({
                nodeCode: key,
                nodeInputs: obj[key],
                remark: ""
              });
            }
          }
        }
      };
      recursion(data);
      return arr;
    },
    // 保存
    onSave() {
      const flag = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      const archiveRecord = {
        bizKeyCode: this.memberId,
        remark: "",
        children: this.formatData(this.ruleForm)
      };
      this.loading = true
      memberArchiveSaveOrUpdateRecord({
        archiveRecord,
        memberId: this.memberId
      }).then(res => {
        this.$message.success('操作成功')
      }).finally(_=>{
        this.loading = false
        this.$emit("handleEdit", 1);
      })
    },
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.reset()
      this.$emit("handleEdit", 1);
    }
  }
};
</script>

<style lang="less" scoped></style>
